import AlertIcon from "_+_Portal/assets/images/generico/AlertIcon";
import {
  CardOrdenDigitalBody,
  CardOrdenDigitalBoton,
  CardOrdenDigitalBotonOutl,
  CardOrdenDigitalBotonOutline,
  CardOrdenDigitalBotones,
  CardOrdenDigitalContainer,
  CardOrdenDigitalDatos,
  CardOrdenDigitalHeader,
  CardOrdenDigitalMensaje,
} from "./localStyle";
import PdfIcon from "_+_Portal/assets/images/generico/PdfIcon";
import { amOrPm } from "global/utils/amOrPm";
import PuertaIcon from "_+_Portal/assets/images/generico/PuertaIcon";
import fechaTurnoFormat from "global/utils/fechaTurnoFormat";
import { wsGetLaboCentros } from "_+_Portal/context/Actions/laboGrupo/laboGrupo";
import {
  setBuscarTurnoLabo,
  setFlgCambiarTurno,
  wsGetLaboTurnos,
} from "_+_Portal/context/Actions/turnos/laboTurnos";
import { useContext, useEffect, useState } from "react";
import { PortalContext } from "_+_Portal/context/Provider";
import ContactoRctaModal from "../ContactoRctaModal/ContactoRctaModal";

import CancelaOrdenDigitalLaboratorio from "../CancelaOrdenDigital/CancelaOrdenDigitalLaboratorio";
import { GlobalContext } from "global/context/Provider";
import VerOrdenDigitalLaboratorio from "../VerOrdenDigitalLaboratorio/VerOrdenDigitalLaboratorio";
import {
  setAltaTurnoOrdenDigital,
  setFlgVolverOrdenDigital,
  setLoadingOrdenDigital,
  setMedicoOrigSolicitante,
  setFechaOrdenLabDigital,
} from "_+_Portal/context/Actions/labOrdenDigital/labOrdenDigital";
import { getStrDate } from "global/utils/diasData";
import { useHistory } from "react-router";
import { wsGetTurnosPaciente } from "_+_Portal/context/Actions/turnos/turnosPaciente";
import { resetTurnosPaciente } from "_+_Portal/context/Actions/turnos/turnosPaciente";
import {
  resetPDFOrdenDigital,
  wsGetPDFOrdenDigital,
} from "_+_Portal/context/Actions/pdfOrdenDigital/pdfOrdenDigital";
import { hideModal, showModal } from "_+_Portal/context/Actions/modal/modal";
import { showToaster } from "global/context/action/toaster/toaster";
import { detectarIOS } from "global/utils/detectarIOS";
import { Device } from "@capacitor/device";
import { base64toBlob } from "global/utils/base64toBlob";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { FileOpener } from "@capacitor-community/file-opener";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import {
  resetPDFOrdenEstudio,
  setAltaOrdenDigitalEstudio,
  setFlgVolverOrdenDigitalEstudio,
  setLoadingOrdenDigitalEstudio,
  setMedicoSolicitante,
  setFechaOrdenDigital,
  wsGetGrupoByIdOrden,
  wsGetPDFOrdenEstudio,
} from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { isMobile } from "react-device-detect";
import camelize from "global/utils/camelize";

const CardOrdenDigital = ({ data }) => {
  //#region -------- contexto --------------
  const {
    laboTurnosDispatch,
    laboGrupoDispatch,
    labOrdenDigitalDispatch,
    ordenDigitalDispatch,
    ordenDigitalState,
    turnosPacienteDispatch,
    pdfOrdenDigitalDispatch,
    pdfOrdenDigitalState,
    modalDispatch,
  } = useContext(PortalContext);
  const { toasterDispatch, configState } = useContext(GlobalContext);
  //#endregion ------ contexto --------------

  //#region -------- constantes --------------

  const flgOrdenAsociada = data.idLabProtAgenda > 0 || data.idTurno > 0;
  const esLabo = !!data.idprotocolo;
  // Orden de prácticas externas RCTA (Cemedic): fuera del circuito de turnos.
  // No ofrece "Tomar turno"; muestra "Hablanos" (WhatsApp).
  const esRctaExterna = !!data.esRctaExterna;
  const [openHablanos, setOpenHablanos] = useState(false);
  const opcLaboratorio = configState?.config?.data?.opcLaboratorio !== false;
  const ordenAsociadaTxt = esRctaExterna
    ? "Para coordinar un turno, contactanos por WhatsApp"
    : flgOrdenAsociada
    ? "Orden asociada a un turno"
    : "Orden sin un turno asociado";
  const ordenCancelada = "El turno ha sido cancelado";
  const history = useHistory();
  const ua = navigator.userAgent || "";
  // Flags vienen del DTO del backend (computadas en el handler segun la duracion
  // configurada por la OS del paciente). Estudios usa `fecha`.
  // POSTDATADO LABO: `fechaimpresion` se reutiliza como fecha diferida de la orden
  // (equivalente a `fecha` en estudios). Las ordenes previas al cambio llegan con
  // fechaimpresion default ("0001-01-01") -> la fecha efectiva sigue siendo fechaalta.
  const esFechaValida = (d) => d && new Date(d).getFullYear() > 1900;
  const fechaEfectivaLabo = esFechaValida(data.fechaimpresion)
    ? data.fechaimpresion
    : data.fechaAlta || data.fechaalta;
  const esOrdenFutura = !!data.enEspera;
  const esOrdenVencida = !!data.vencida;
  const fechaValidezOrigen = data.fecha || fechaEfectivaLabo;
  const fechaValidezFormatted = esOrdenFutura && fechaValidezOrigen
    ? new Date(fechaValidezOrigen).toLocaleDateString("es-AR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    : null;
  //#endregion ------ constantes --------------

  //#region --------- funciones --------------

  const cambiarTurno = () => {
    const fecha = fechaTurnoFormat();
    const idGrupoTurnoLaboGeneral = 5;
    wsGetLaboCentros()(laboGrupoDispatch);
    setFlgCambiarTurno(true)(laboTurnosDispatch);
    setFlgVolverOrdenDigital(true)(labOrdenDigitalDispatch);
    wsGetLaboTurnos(fecha, -1, -1, idGrupoTurnoLaboGeneral)(laboTurnosDispatch);
    setAltaTurnoOrdenDigital(data?.idprotocolo)(labOrdenDigitalDispatch);
    setBuscarTurnoLabo(true)(laboTurnosDispatch);
    setLoadingOrdenDigital(true)(labOrdenDigitalDispatch);
    setMedicoOrigSolicitante(data?.medicoOrig || null)(labOrdenDigitalDispatch);
    hideModal()(modalDispatch);
  };

  const cancelarTurno = () => {
    setFlgCambiarTurno(false)(laboTurnosDispatch);
    hideModal()(modalDispatch);
  };

  const showModalcancelarTurno = () => {
    showModal(
      <CancelaOrdenDigitalLaboratorio
        cambiarTurno={cambiarTurno}
        cancelarTurno={cancelarTurno}
      />,
      "Cancelar Orden Digital",
      cerrarModal,
      false,
      [],
      "",
      true
    )(modalDispatch);
  };

  // Orden postdatada (enEspera): la búsqueda de turnos arranca desde la fecha de la
  // orden (labo: fecha efectiva = fechaimpresion ?? fechaalta). Se guarda en contexto
  // para el default del buscador y la validación al confirmar.
  const formatYMD = (d) => {
    const f = new Date(d);
    const m = f.getMonth() + 1;
    const day = f.getDate();
    return `${f.getFullYear()}-${m < 10 ? "0" + m : m}-${
      day < 10 ? "0" + day : day
    }`;
  };

  const asociarTurno = () => {
    const fechaPostdatada =
      data?.enEspera && fechaEfectivaLabo ? formatYMD(fechaEfectivaLabo) : null;
    const fecha = fechaPostdatada || fechaTurnoFormat();
    const idGrupoTurnoLaboGeneral = 5;
    setLoadingOrdenDigital(true)(labOrdenDigitalDispatch);
    setFlgVolverOrdenDigital(true)(labOrdenDigitalDispatch);
    setFechaOrdenLabDigital(fechaPostdatada)(labOrdenDigitalDispatch);
    wsGetLaboCentros()(laboGrupoDispatch);
    wsGetLaboTurnos(fecha, -1, -1, idGrupoTurnoLaboGeneral)(laboTurnosDispatch);
    setAltaTurnoOrdenDigital(data?.idprotocolo)(labOrdenDigitalDispatch);
    setBuscarTurnoLabo(true)(laboTurnosDispatch);
    setMedicoOrigSolicitante(data?.medicoOrig || null)(labOrdenDigitalDispatch);
  };

  const asociarTurnoEstudio = () => {
    wsGetGrupoByIdOrden(data.id)(ordenDigitalDispatch);
    setAltaOrdenDigitalEstudio(data.id)(ordenDigitalDispatch);
    setMedicoSolicitante(data?.idMedSolicitante || null)(ordenDigitalDispatch);
    // Si la orden está postdatada, llevar su fecha para arrancar la búsqueda ahí.
    setFechaOrdenDigital(
      data?.enEspera && data?.fecha ? formatYMD(data.fecha) : null
    )(ordenDigitalDispatch);
  };

  useEffect(() => {
    if (ordenDigitalState.ordenDigital.grupoMed !== null) {
      setLoadingOrdenDigitalEstudio(true)(ordenDigitalDispatch);
      setFlgVolverOrdenDigitalEstudio(true)(ordenDigitalDispatch);
      if (isMobile) {
        history.push("/estudios");
      } else {
        history.push("/buscadorTurnos");
      }
    }
  }, [ordenDigitalState.ordenDigital.grupoMed]);

  const verOrden = async () => {
    // Validar si existe URL de receta externa
    if (
      data?.linkPdfRcta &&
      typeof data.linkPdfRcta === "string" &&
      data.linkPdfRcta.trim() !== ""
    ) {
      try {
        if (Capacitor.isNativePlatform()) {
          // Abrir en navegador nativo para móviles (Android/iOS)
          await Browser.open({ url: data.linkPdfRcta });
        } else {
          // Abrir en nueva pestaña para web
          window.open(data.linkPdfRcta, "_blank");
        }
      } catch (error) {
        console.error("Error al abrir la URL:", error);
        showToaster(
          {
            texto: "Error al abrir el documento",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    } else {
      // Lógica actual: descargar PDF desde backend
      if (data?.idprotocolo) {
        wsGetPDFOrdenDigital(data?.id, nextStepOrden)(pdfOrdenDigitalDispatch);
      } else {
        wsGetPDFOrdenEstudio(data.id, nextStepOrden)(ordenDigitalDispatch);
      }
    }
  };

  const nextStepOrden = (isCorrect, dataPdf) => {
    if (isCorrect) {
      const normalize = async (input) => {
        if (input && input.blob instanceof Blob)
          return { blob: input.blob, base64: await blobToBase64(input.blob) };
        if (input instanceof Blob)
          return { blob: input, base64: await blobToBase64(input) };
        if (typeof input === "string")
          return {
            blob: base64toBlob(input, "application/pdf"),
            base64: input,
          };
        return { blob: null, base64: null };
      };
      const blobToBase64 = (blob) =>
        new Promise((resolve, reject) => {
          try {
            const reader = new FileReader();
            reader.onloadend = () => {
              const result = reader.result || "";
              const str = typeof result === "string" ? result : "";
              const commaIdx = str.indexOf(",");
              resolve(commaIdx >= 0 ? str.substring(commaIdx + 1) : str);
            };
            reader.onerror = (e) => reject(e);
            reader.readAsDataURL(blob);
          } catch (e) {
            reject(e);
          }
        });

      (async () => {
        const { blob, base64 } = await normalize(dataPdf);
        if (isMobile) {
          const isIOS = detectarIOS();
          if (isIOS) {
            Device.getInfo().then((info) => {
              if (info.platform === "web") {
                const blobUrl = URL.createObjectURL(blob);
                const descarga = document.createElement(`a`);
                descarga.href = blobUrl;
                descarga.target = "_blank";
                descarga.download = `OrdenDig-${data.idTurnoOrigen}.pdf`;
                document.body.appendChild(descarga);
                descarga.click();
                document.body.removeChild(descarga);
                setTimeout(() => URL.revokeObjectURL(blobUrl), 0);
              } else {
                downloadiOSFileNative(base64);
              }
            });
          } else {
            Device.getInfo().then((info) => {
              const isGoogleAppWebView = /GSA/.test(ua);
              if (isGoogleAppWebView) {
                const url = URL.createObjectURL(blob);
                window.open(url, "_blank");
              } else {
                if (info.platform === "web") {
                  const blobUrl = URL.createObjectURL(blob);
                  const descarga = document.createElement("a");
                  descarga.href = blobUrl;
                  descarga.target = "_blank";
                  descarga.download = `OrdenDig-${data.idTurnoOrigen}.pdf`;
                  document.body.appendChild(descarga);
                  descarga.click();
                  setTimeout(() => URL.revokeObjectURL(blobUrl), 0);
                } else {
                  downloadPdfAndroidNative(base64);
                }
              }
            });
          }
          resetPDFOrdenEstudio()(ordenDigitalDispatch);
        } else {
          showModal(
            "Turnos/VerOrdenDigitalLaboratorio/VerOrdenDigitalLaboratorio",
            {
              titulo: `Documento`,
              base64: base64,
            },
            [],
            "centro",
            true
          )(modalDispatch);
        }
      })();
    } else {
      showToaster(
        {
          texto: "Error al mostrar el documento",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
    resetPDFOrdenDigital()(pdfOrdenDigitalDispatch);
    resetPDFOrdenEstudio()(ordenDigitalDispatch);
  };

  const cerrarModal = () => {
    hideModal()(modalDispatch);
  };

  const verDetallesTurno = () => {
    resetTurnosPaciente()(turnosPacienteDispatch);
    history.push("/proximosTurnos");
  };

  const formatFechaData = (fecha) => {
    if (typeof fecha !== "object") {
      fecha = fecha.split("T");
      fecha = fecha[0].split("-");
      return `${fecha[2]}/${fecha[1]}/${fecha[0]}`;
    } else {
      return fecha;
    }
  };

  const downloadiOSFileNative = (pdfBase64) => {
    const b64Data = pdfBase64;
    const fileName = `Informe-${data.idTurno}.pdf`;
    Filesystem.writeFile({
      path: fileName,
      data: b64Data,
      directory: Directory.Documents,
    }).then((c) => {
      const rutaGuardado = c.uri;
      try {
        const fileOpenerOptions = {
          filePath: rutaGuardado,
          contentType: "application/pdf",
          openWithDefault: true,
        };
        FileOpener.open(fileOpenerOptions);
      } catch (e) {
        console.log("Error opening file", e);
      }
    });
  };

  const downloadPdfAndroidNative = (pdfBase64) => {
    const b64Data = pdfBase64;
    const currentDate = new Date().toLocaleString().replace(/[,:\s\/]/g, "-");
    const fileName = `Informe-${currentDate}.pdf`;
    Filesystem.writeFile({
      path: `Download/${fileName}`,
      data: b64Data,
      directory: Directory.ExternalStorage,
    }).then((c) => {
      const rutaGuardado = c.uri;
      try {
        const fileOpenerOptions = {
          filePath: rutaGuardado,
          contentType: "application/pdf",
          openWithDefault: true,
        };
        FileOpener.open(fileOpenerOptions);
      } catch (e) {
        console.log("Error opening file", e);
      }
    });
  };

  const verificarFecha = (turnoDate) => {
    const turnoFecha = new Date(turnoDate);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (turnoFecha < today) {
      return false;
    } else {
      return true;
    }
  };
  //#endregion ------ funciones --------------

  //#region ------ useEffect --------------
  //#endregion ------ useEffect --------------

  return (
    <CardOrdenDigitalContainer>
      <CardOrdenDigitalHeader>
        <PuertaIcon />
        <span className="rb18b">
          {data.idprotocolo
            ? "Laboratorio"
            : data.idGrupoEstudioDesc !== null
            ? camelize(data.idGrupoEstudioDesc)
            : "Estudio"}
        </span>
      </CardOrdenDigitalHeader>
      <CardOrdenDigitalBody>
        <CardOrdenDigitalDatos>
          <span>
            {/* Labo con fechaimpresion (postdatada): igual que estudios -> "Emitida el: fechaalta"
                y el helper azul de abajo muestra "Válida desde {fechaimpresion}".
                Labo SIN fechaimpresion (ordenes previas al cambio / no postdatadas):
                "Válida desde: fechaalta". Estudios siempre "Emitida el". */}
            {data.idprotocolo && !esFechaValida(data.fechaimpresion)
              ? "Válida desde:"
              : "Emitida el:"}{" "}
            {/* <span className="rb18b">{formatFechaData(data.fechaalta)} </span> */}
            <span className="rb18b">
              {new Date(
                data.fechaAlta ? data.fechaAlta : data.fechaalta
              ).toLocaleDateString("es-AR", {
                day: "2-digit",
                month: "2-digit",
                year: "2-digit",
              })}{" "}
            </span>
          </span>
          <span>
            Médico:{" "}
            <span className="rb18b">
              {data.idprotocolo
                ? data.medicoOrig === data.idUsuarioAlta
                  ? `${data.idUsuarioAltaDesc}`
                  : `${data.medicoOrigDesc}`
                : `${data.idUsuarioAltaDesc}`}
            </span>
          </span>
          {flgOrdenAsociada && data.idprotocolo && (
            <>
              <span className="rb18b">
                {getStrDate(new Date(data.fechaTurno), true)}
              </span>
              <span>
                Horario:{" "}
                <span className="rb18b">
                  {data.horaTurnoDesc + " " + amOrPm(data.horaTurnoDesc)}
                </span>
              </span>
              <span>
                Centro: <span className="rb18b">{data.idCentroDesc}</span>
              </span>
              {/* <span className="ordenDigital-direccion">Rivadavia</span> */}
            </>
          )}
          {!data.cancelado && (
            <>
              <CardOrdenDigitalBotonOutline onClick={verOrden}>
                <PdfIcon />
                <span className="rb16b">Orden</span>
              </CardOrdenDigitalBotonOutline>
            </>
          )}
          {!data.requiereTurno && !esOrdenFutura && !esOrdenVencida ? (
            <CardOrdenDigitalMensaje
              $flgOrdenAsociada={flgOrdenAsociada}
              $cancelado={data.cancelado}
            >
              <AlertIcon
                color={
                  flgOrdenAsociada && !data.cancelado
                    ? "var(--color-broccoli)"
                    : "var(--color-danger)"
                }
              />
              <span className="rb14b">
                {data.idprotocolo
                  ? ordenAsociadaTxt
                  : data.cancelado
                  ? ordenCancelada
                  : ordenAsociadaTxt}
              </span>
            </CardOrdenDigitalMensaje>
          ) : (
            ""
          )}
        </CardOrdenDigitalDatos>
        <CardOrdenDigitalBotones>
          {esRctaExterna ? (
            <CardOrdenDigitalBoton
              onClick={() => setOpenHablanos(true)}
              className="rb16b c-white"
              style={{
                background: "#1da851",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
              }}
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                width="20"
                height="20"
                style={{ color: "#fff" }}
                aria-hidden
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              <span className="c-white">Contáctanos</span>
            </CardOrdenDigitalBoton>
          ) : flgOrdenAsociada ? (
            <>
              {esLabo ? (
                opcLaboratorio && (
                  <CardOrdenDigitalBoton
                    onClick={cambiarTurno}
                    className="bgc-danger rb16b c-white"
                  >
                    Cambiar turno
                  </CardOrdenDigitalBoton>
                )
              ) : data.presente === true ? (
                ""
              ) : (
                <CardOrdenDigitalBoton
                  onClick={asociarTurnoEstudio}
                  className="bgc-danger rb16b c-white"
                >
                  {data.cancelado ? "Tomar un turno" : "Cambiar turno"}
                </CardOrdenDigitalBoton>
              )}

              {verificarFecha(data.fechaTurno) &&
                (esLabo ? (
                  <CardOrdenDigitalBotonOutl
                    onClick={verDetallesTurno}
                    className="rb16b c-latex30"
                  >
                    Ver detalles del turno
                  </CardOrdenDigitalBotonOutl>
                ) : !data.cancelado ? (
                  <CardOrdenDigitalBotonOutl
                    onClick={verDetallesTurno}
                    className="rb16b c-latex30"
                  >
                    Ver detalles del turno
                  </CardOrdenDigitalBotonOutl>
                ) : (
                  ""
                ))}
            </>
          ) : (
            <>
              {!data.requiereTurno ? (
                esOrdenFutura ? (
                  esLabo && !opcLaboratorio ? (
                    <p className="rb16l c-latex30">
                      La toma de turnos de laboratorio no está disponible.
                    </p>
                  ) : (
                    <>
                      <p
                        className="rb14l c-latex30"
                        style={{ textAlign: "center" }}
                      >
                        Válida desde {fechaValidezFormatted}
                      </p>
                      <CardOrdenDigitalBoton
                        onClick={esLabo ? asociarTurno : asociarTurnoEstudio}
                        className="bgc-danger rb16b"
                      >
                        <span className="c-white">Tomar un turno</span>
                      </CardOrdenDigitalBoton>
                    </>
                  )
                ) : esOrdenVencida ? (
                  <p className="rb16l c-latex30" style={{ textAlign: "center" }}>
                    Orden vencida — fuera del plazo de validez de su obra social
                  </p>
                ) : esLabo && !opcLaboratorio ? (
                  <p className="rb16l c-latex30">
                    La toma de turnos de laboratorio no está disponible.
                  </p>
                ) : (
                  <CardOrdenDigitalBoton
                    onClick={esLabo ? asociarTurno : asociarTurnoEstudio}
                    className="bgc-danger rb16b"
                  >
                    <span className="c-white">Tomar un turno</span>
                  </CardOrdenDigitalBoton>
                )
              ) : (
                <p className="rb16l c-latex30">
                  La orden no requiere un turno. Puede acercarse al centro más
                  cercano.
                </p>
              )}
            </>
          )}
        </CardOrdenDigitalBotones>
      </CardOrdenDigitalBody>
      {openHablanos && (
        <ContactoRctaModal onClose={() => setOpenHablanos(false)} />
      )}
    </CardOrdenDigitalContainer>
  );
};

export default CardOrdenDigital;
